<div [formGroup]="form()">
  @let comments = form().get("comments");
  <app-pan-form-control>
    <app-pan-floating-label for="comments">Comments</app-pan-floating-label>
    <textarea
      panTextarea
      formControlName="comments"
      id="comments"
      placeholder="Describe your findings here..."
      rows="4"
      data-testid="comments"
      [color]="
        comments?.errors?.commentsRequired || comments?.errors?.commentsMinLength || comments?.errors?.commentsMaxLength
          ? 'danger'
          : 'default'
      "
    ></textarea>
    <div class="flex justify-between items-center mt-1">
      <div>
        @if (required() && comments?.errors?.commentsRequired) {
          <div class="text-danger mt-1" role="alert" data-testid="commentsError">Comments are required.</div>
        } @else if (required() && comments?.errors?.commentsMinLength) {
          <div class="text-danger mt-1" role="alert" data-testid="commentsMinError">Minimum 10 characters required.</div>
        } @else if (required() && comments?.errors?.commentsMaxLength) {
          <div class="text-danger mt-1" role="alert" data-testid="commentsMaxError">Maximum 2000 characters allowed.</div>
        }
      </div>

      <div class="text-xs text-gray-500 mt-1">{{ 2000 - (comments?.value?.length || 0) }} characters remaining</div>
    </div>
  </app-pan-form-control>
</div>
